import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function AboutTeaser() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* Image */}
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden w-full h-[420px] md:h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/aaf6d1619642d1db2e93b9d0d5f91e00.jpg"
                alt="MAX Sails Canada workshop - quality sail making"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
            </div>
          </div>

          {/* Text */}
          <div className="w-full lg:w-1/2">
            <p className="text-red-600 text-xs uppercase tracking-[0.3em] font-semibold mb-3">{t('about_label')}</p>
            <h2
              className="text-4xl md:text-5xl font-black text-gray-900 leading-tight mb-6"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              {t('about_title_1')}<br />
              <span className="text-red-600">{t('about_title_2')}</span>
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-5">{t('about_p1')}</p>
            <p className="text-gray-600 text-base leading-relaxed mb-5">{t('about_p2')}</p>
            <p className="text-gray-600 text-base leading-relaxed mb-8">{t('about_p3')}</p>

            <Link
              to="/products"
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-gray-900 text-white text-sm font-semibold hover:bg-red-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('about_cta')}
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
